export function hasPairedOpenClawIdentity(identity) {
  const platformKey = identity?.platform_key
  return typeof platformKey === "string" && platformKey.trim().length > 0
}

export function needsOpenClawOnboarding(identity) {
  return !hasPairedOpenClawIdentity(identity)
}

